import { FC } from 'react';
import { Flex } from '@chakra-ui/layout';
import {
  Grid,
  GridItem,
  Skeleton,
  useMediaQuery,
  Heading,
  Link as ChakraLink,
  Button
} from '@chakra-ui/react';
import { useWeb3React } from 'hooks/web3';
import { useSelectedCrucible } from 'store/selectedCrucible';
import { Link } from 'react-router-dom';
import { useModal } from 'store/modals';
import { ModalType } from 'components/modals/types';
import { VscLink } from 'react-icons/vsc';
import { useConnection } from 'store/connection';
import { useCrucibles } from 'hooks/query/useCrucibles';
import CrucibleDetailCard from 'components/crucible/detail/CrucibleDetailCard';
import CruciblesListView from 'components/crucible/CruciblesListView';
import {
  usePrograms,
  useProgramsRewards,
  useProgramsStaked
} from 'hooks/query/usePrograms';

const Crucibles: FC = () => {
  usePrograms();
  useProgramsRewards();
  useProgramsStaked();

  const { account } = useWeb3React();
  const { openModal } = useModal();
  const { tried } = useConnection();
  const { data: crucibles, isLoading: cruciblesLoading } = useCrucibles();
  const { selectedCrucible } = useSelectedCrucible();
  const [isLargerThan992] = useMediaQuery('(min-width: 992px)');

  if (tried && !account) {
    return (
      <>
        <Flex
          justifyContent='center'
          alignItems='center'
          py={10}
          flexDir='column'
        >
          <Heading size='lg' textAlign='center' mb={4}>
            Connect your wallet to view your Crucibles.
          </Heading>
          <Button
            size='lg'
            rightIcon={<VscLink />}
            onClick={() => openModal(ModalType.connectWallet)}
          >
            Connect Wallet
          </Button>
        </Flex>
      </>
    );
  }

  if (tried && account && crucibles?.length === 0 && !cruciblesLoading) {
    return (
      <>
        <Flex justifyContent='center' alignItems='center' py={10}>
          <Heading size='lg' textAlign='center'>
            You have no Crucibles.{' '}
            <ChakraLink
              as={Link}
              to='/mint'
              color='cyan.500'
              textDecor='underline'
            >
              Mint one now
            </ChakraLink>
          </Heading>
        </Flex>
      </>
    );
  }

  return (
    <>
      <Grid gridTemplateColumns={isLargerThan992 ? '260px 1fr' : '1fr'} gap={8}>
        {isLargerThan992 && (
          <Skeleton
            isLoaded={!cruciblesLoading && !!selectedCrucible && tried}
            startColor='gray.700'
            endColor='gray.800'
            borderRadius='xl'
          >
            <GridItem>
              <CruciblesListView />
            </GridItem>
          </Skeleton>
        )}
        <Skeleton
          isLoaded={!cruciblesLoading && !!selectedCrucible && tried}
          startColor='gray.700'
          endColor='gray.800'
          borderRadius='xl'
        >
          <GridItem>
            <CrucibleDetailCard crucible={selectedCrucible!} />
          </GridItem>
        </Skeleton>
      </Grid>
    </>
  );
};

export default Crucibles;
